import React, { useEffect, useState } from "react";
import { FaPlusCircle } from "react-icons/fa";
import Sidebar from "../../components/Nav/AdminSidebar";

const AddRoomForm = () => {
  const [categories, setCategories] = useState([]);
  const [roomNo, setRoomNo] = useState("");
  const [selectedCategory, setSelectedCategory] = useState("");
  const [price, setPrice] = useState("");
  const [availability, setAvailability] = useState(true);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [successMessage, setSuccessMessage] = useState("");
  const BASE_URL = process.env.REACT_APP_SERVER_BASE_URL;

  // Fetch room categories
  useEffect(() => {
    fetch(`${BASE_URL}/room/get-room-cat.php`)
      .then((res) => res.json())
      .then((data) => {
        if (data.success) {
          setCategories(data.data);
        } else {
          setError("Failed to load categories");
        }
        setLoading(false);
      })
      .catch((err) => {
        console.error(err);
        setError("Error fetching categories");
        setLoading(false);
      });
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setSuccessMessage("");

    if (!roomNo || !selectedCategory || !price) {
      setError("Please fill all fields.");
      return;
    }
    console.log(roomNo, selectedCategory, price, availability);
    try {
      const res = await fetch(`${BASE_URL}/room/add-room.php`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          room_no: roomNo,
          category_id: selectedCategory,
          availability: availability,
          price: price,
        }),
      });

      const result = await res.json();

      if (result.success) {
        setSuccessMessage(`Room added successfully! ID: ${result.room_id}`);
        setRoomNo("");
        setSelectedCategory("");
        setPrice("");
        setAvailability(true);
      } else {
        setError(result.error || "Failed to add room");
      }
    } catch (err) {
      console.error(err);
      setError("Error adding room");
    }
  };

  return (
    <div className="flex min-h-screen bg-gray-50 text-gray-900">
      <Sidebar />

      <main className="flex-1 p-6">
        <div className="max-w-xl mx-auto bg-white border border-gray-200 rounded-lg shadow-md p-6 mt-8">
          <h2 className="text-2xl font-semibold mb-5 flex items-center gap-2 text-blue-600">
            <FaPlusCircle className="text-blue-500" />
            Add New Room
          </h2>

          {loading && (
            <p className="text-gray-500 mb-3">Loading categories...</p>
          )}
          {error && <p className="text-red-500 mb-3">{error}</p>}
          {successMessage && (
            <p className="text-green-600 mb-3">{successMessage}</p>
          )}

          <form onSubmit={handleSubmit} className="space-y-5">
            {/* Room Number */}
            <div>
              <label className="block text-sm font-medium mb-1">
                Room Number
              </label>
              <input
                type="text"
                value={roomNo}
                onChange={(e) => setRoomNo(e.target.value)}
                className="w-full border border-gray-300 rounded-md px-4 py-2 focus:outline-none focus:ring-2 focus:ring-blue-400"
                placeholder="Enter room number"
              />
            </div>

            {/* Category */}
            <div>
              <label className="block text-sm font-medium mb-1">Category</label>
              <select
                value={selectedCategory}
                onChange={(e) => setSelectedCategory(e.target.value)}
                className="w-full border border-gray-300 rounded-md px-4 py-2 bg-white focus:outline-none focus:ring-2 focus:ring-blue-400"
              >
                <option value="">Select a category</option>
                {categories.map((cat) => (
                  <option key={cat.category_id} value={cat.category_id}>
                    {cat.category_name}
                  </option>
                ))}
              </select>
            </div>

            {/* Price */}
            <div>
              <label className="block text-sm font-medium mb-1">
                Price (₹)
              </label>
              <input
                type="number"
                step="0.01"
                value={price}
                onChange={(e) => setPrice(e.target.value)}
                className="w-full border border-gray-300 rounded-md px-4 py-2 focus:outline-none focus:ring-2 focus:ring-blue-400"
                placeholder="Enter price"
              />
            </div>

      

            {/* Submit */}
            <button
              type="submit"
              className="w-full bg-blue-600 text-white py-2 rounded-md font-medium hover:bg-blue-700 transition"
            >
              Add Room
            </button>
          </form>
        </div>
      </main>
    </div>
  );
};

export default AddRoomForm;
